import { ThemeProvider, CssBaseline, useMediaQuery } from '@mui/material';
import { useState, useEffect } from 'react';
import { lightTheme, darkTheme } from './Theme';
const Themeprovider = ({ children }) => {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  const [theme, setTheme] = useState(lightTheme);

  useEffect(() => {
    setTheme(prefersDarkMode ? darkTheme : lightTheme);
  }, [prefersDarkMode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default Themeprovider;